/**
 * User: nir
 * Date: 30/09/2016
 * Time: 14:32
 */

if (window.jQuery) {
    window.jQuery(function ($) {
        var selector = '[data-swipe]',
            elements = $(selector);

        elements.each(function (i, e) {
            var element = $(e);

            element.on('touchstart', handleTouchStart);
            element.on('touchmove', handleTouchMove);

            var xDown = null;
            var yDown = null;

            function handleTouchStart(evt) {
                xDown = evt.originalEvent.touches[0].clientX;
                yDown = evt.originalEvent.touches[0].clientY;
            }

            function handleTouchMove(evt) {
                if ( ! xDown || ! yDown ) {
                    return;
                }

                var xUp = evt.originalEvent.touches[0].clientX;
                var yUp = evt.originalEvent.touches[0].clientY;

                var xDiff = xDown - xUp;
                var yDiff = yDown - yUp;

                if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
                    if ( xDiff > 0 ) {
                        element.trigger('swipe-left');
                    } else {
                        element.trigger('swipe-right');
                    }
                } else {
                    if ( yDiff > 0 ) {
                        element.trigger('swipe-up');
                    } else {
                        element.trigger('swipe-down');
                    }
                }

                /* reset values */
                xDown = null;
                yDown = null;
            }
        });
    });
}